import { useState } from 'react';
import { toast } from 'react-toastify';
import { KTIcon } from "../../../../_metronic/helpers";
import FileDownload from "js-file-download";
import axios from 'axios';
const EmailModalForm = ({
  cycleId,
  onClose
}) => {
  const [emails, setEmails] = useState(['']);
  const [isLoading, setIsLoading] = useState(false)

  const validEmail = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  const downloadFile = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/promo/cycles/download?cycle_id=${cycleId}`,
        { email: !!emails?.length ? emails?.map((el) => el).join(',') : '' },
        { responseType: 'blob' }
      );
      const disposition = response.headers['content-disposition'];
      let filename = 'promo_code.xlsx';
      if (disposition && disposition.includes('filename=')) {
        const match = disposition.match(/filename="?([^"]+)"?/);
        if (match && match[1]) {
          filename = match[1];
        }
      }
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      FileDownload(blob, filename);
      toast.success(`${emails[0] ? 'Promo code file downloaded and sent on email succesfully' : 'Promo code file downloaded successfully'}`);
      setIsLoading(false);
      onClose();
    } catch (error) {
      toast.error('Error downloading file');
      setIsLoading(false);
    }
  };

  const isDisabled = () => {
    let result = false

    if (emails?.length) {
      const hasInvalidEmail = emails.some((email) => {
        if (!email || email === "") {
          return false
        }
        const re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return !re.test(String(email).toLowerCase());
      });
      if (hasInvalidEmail) {
        result = true
      }
    } else if (!emails?.length) {
      result = true
    }

    if (isLoading) {
      result = true
    }

    return result
  }

  return (
    <>
      <div className="fv-row" style={{ maxHeight: '380px', overflowY: 'auto', minHeight: 'auto' }}>
        <label className="fw-bold fs-6 mb-2">Add Email (Optional)</label>
        <div className="d-flex gap-2 flex-column" style={{ position: "relative" }}>
          {
            emails.map((el, i) => (
              <div style={{ position: "relative" }}>
                <input className="form-control form-control-solid" value={emails[i]}
                  placeholder="Enter Notifier Email"
                  onChange={(e) => {
                    const newEmails = [...emails];
                    newEmails[i] = e.target.value;
                    setEmails(newEmails);
                  }}
                  onBlur={(e) => {
                    if (e.target.value && !validEmail(e.target.value)) {
                      toast.error('Invalid notifier email');
                    }
                  }
                  }
                />
                {i !== 0 && <button
                  className="remove"
                  style={{ right: "10px", top: "12px" }}
                  onClick={() => {
                    if (emails.length === 1) {
                      setEmails(['']);
                    } else {
                      setEmails(emails.filter((_, index) => index !== i));
                    }
                  }}
                >
                  <KTIcon iconName="cross" />
                </button>
                }
                {cycleId && validEmail(emails[0]) && <button
                  className="remove"
                  style={{ right: "10px", top: "12px" }}
                  onClick={() => {
                    if (emails.length === 1) {
                      setEmails(['']);
                    } else {
                      setEmails(emails.filter((_, index) => index !== i));
                    }
                  }}
                >
                  <KTIcon iconName="cross" />
                </button>
                }
              </div>
            ))
          }
        </div>
        {(emails[emails.length - 1] && validEmail(emails[emails.length - 1])) && <button
          type="reset"
          onClick={() => {
            setEmails([...emails, '']);
          }}
          className="btn btn-dark w-100 mt-3"
          data-kt-users-modal-action="cancel"
        >
          + Add Another Notifier Email
        </button>
        }
      </div>
      <div className="text-center pt-5">
        <button
          type="reset"
          onClick={() => onClose()}
          className="btn btn-light mx-3"
          data-kt-users-modal-action="cancel"
        >
          Discard
        </button>
        <button
          type="submit"
          className="btn"
          data-kt-users-modal-action="submit"
          style={{ background: "#ffa459", color: "#fff" }}
          onClick={() => downloadFile()}
          disabled={isDisabled()}
        >
          Download File
        </button>
      </div>
    </>
  );
};

export { EmailModalForm };
